<template>
  <div class="app-filter__slides">
    <swiper v-show="selectedPost !== null" :options="swiperOption">
      <swiper-slide v-for="(img, index) in imagesList" :key="index">
        <v-layout class="mr-0 ml-0">
          <v-flex xs6>
            <v-img
              :src="img.before.src"
              :lazy-src="img.before.lazySrc"
              :width="'100%'"
              class="grey lighten-4 app-filter__slide-image"
            >
              <v-layout
                slot="placeholder"
                fill-height
                align-center
                justify-center
                ma-0
              >
                <v-progress-circular indeterminate color="grey lighten-5" />
              </v-layout>
            </v-img>
          </v-flex>
          <v-flex xs6>
            <v-img
              :src="img.after.src"
              :lazy-src="img.after.lazySrc"
              :width="'100%'"
              class="grey lighten-5 app-filter__slide-image"
            >
              <v-layout
                slot="placeholder"
                fill-height
                align-center
                justify-center
                ma-0
              >
                <v-progress-circular indeterminate color="grey lighten-5" />
              </v-layout>
            </v-img>
          </v-flex>
        </v-layout>
      </swiper-slide>

      <div class="app-filter__pagination" slot="scrollbar">
        <div class="app-filter__slides-captions">
          <span>Before</span>
          <span>After</span>
        </div>
        <div class="app-filter__pagination-wrap">
          <div class="swiper-pagination" slot="pagination"></div>
          <div class="swiper-button-prev" slot="button-prev">
            <v-icon>mdi-chevron-left</v-icon>
          </div>
          <div class="swiper-button-next" slot="button-next">
            <v-icon>mdi-chevron-right</v-icon>
          </div>
        </div>
      </div>
    </swiper>
    <div
      class="app-filter__slide-description"
      v-if="description"
      v-html="description"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      swiperOption: {
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
    }
  },
  computed: {
    ...mapGetters(['selectedPost']),
    imagesList() {
      const { selectedPost } = this

      if (selectedPost === null) {
        return []
      }

      const gallery = selectedPost.acf.gallery_images

      return gallery
        .map(img => {
          const {
            after_image: { sizes: after },
            before_image: { sizes: before },
          } = img

          if (before && after) {
            return {
              before: {
                src: before.large,
                lazySrc: before.shop_thumbnail,
              },
              after: {
                src: after.large,
                lazySrc: after.shop_thumbnail,
              },
            }
          }

          return null
        })
        .filter(e => e !== null)
    },
    description() {
      const { selectedPost } = this

      if (selectedPost !== null) {
        return selectedPost.acf.description
      }

      return ''
    },
  },
}
</script>

<style lang="scss">
$gold: #b28f53;

.app-filter__slides {
  @media (min-width: 960px) {
    padding-left: 12.5%;
    padding-right: 12.5%;
  }
}

.app-filter__slide-image {
  margin-left: auto;
  margin-right: auto;

  .v-responsive__sizer {
    padding-bottom: 151.515% !important; // aspect ratio w/h 0.66
  }
}

.app-filter__slides-captions {
  display: flex;
  position: absolute;
  bottom: 54px;
  width: 100%;
  left: 0;
  z-index: 1;
  justify-content: space-around;
  align-items: center;
  color: white;
  display: none;
  font-family: 'AIModern';
  font-size: 30px;
  line-height: 1;
  pointer-events: none;
}

.app-filter__slide-description {
  letter-spacing: 1px;
  font-size: 16px;
  line-height: 1.1875;
  text-transform: uppercase;
  text-align: center;
  padding: 22px 10px;

  & p {
    margin: 0;
  }

  @media (min-width: 960px) {
    padding-top: 40px;
    padding-right: 40px;
  }
}

.app-filter__pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  width: 100%;
  position: absolute;
  height: 40px;
  bottom: 0;
  left: 0;
  background: rgba(black, 0.5);
  z-index: 10;
  &-wrap {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .swiper-pagination {
    position: relative;
    transform: none;
    order: 2;
    .swiper-pagination-bullet {
      margin: 0 11px;
      border: 1px solid $gold;
      opacity: 1;
      background: transparent;
      &.swiper-pagination-bullet-active {
        background: $gold;
      }
    }
  }
  .swiper-button-prev,
  .swiper-button-next {
    display: flex;
    background: none;
    justify-content: center;
    align-items: center;
    width: 41px;
    height: 41px;
    border-radius: 51%;
    position: relative;
    z-index: 1;
    color: $gold;
    transition: color 0.3s ease;
    top: 0;
    transform: none;
    margin-top: 0;
    margin: 0 5px;
    cursor: pointer;

    .v-icon {
      color: $gold;
      font-size: 30px;
    }

    &:hover {
      transition: color 0.3s ease;
      .v-icon {
        color: white;
        transition: color 0.3s ease;
      }
    }
  }
  .swiper-button-next {
    order: 3;
  }
  .swiper-button-prev {
    order: 1;
  }
}
</style>
